import React from 'react';
import '../LandingPage.css'; // Assuming styles are still here
// Import only specific icons used
import { FaPhone, FaEnvelope, FaFacebook } from 'react-icons/fa';

function ContactSection() {
  return (
    <section id="contact" className="contact-section">
      <div className="section-content">
        <h2>Get In Touch</h2>
        <div className="contact-info">
          <a href="tel:+447935501848" className="contact-link">
            {/* Use direct import */}
            <FaPhone className="phone-icon" />
            +44 7935 501 848
          </a>
          <a href="mailto:emil.filip@efsoft.co.uk" className="contact-link">
            {/* Use direct import */}
            <FaEnvelope className="email-icon" />
            emil.filip@efsoft.co.uk
          </a>
          <a href="https://www.facebook.com/profile.php?id=61572979287197"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link">
            {/* Use direct import */}
            <FaFacebook className="facebook-icon" />
            Follow us on Facebook
          </a>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
